import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { appInsights } from '../../app.module';

@Component({
    selector: 'account/logout',
    template: require('./log.out.successful.component.html')
})
export class LogOutComponent implements OnInit {
constructor(private router: Router) {
    
}

    ngOnInit() {
        appInsights.clearAuthenticatedUserContext();
        this.router.navigate(['/dashboard']);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/userAccounts/log.out.successful.component.ts